import { useEffect } from "react";

export default function AnalyticsEvents() {
  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest && e.target.closest("a");
      if (!a || !window.gtag) return;
      const href = a.getAttribute("href") || "";
      const params = { link_url: href, page_path: window.location.pathname };
      if (href.startsWith("tel:")) {
        window.gtag("event", "phone_click", params);
      } else if (href.startsWith("mailto:")) {
        window.gtag("event", "email_click", params);
      } else if (href === "/epikoinonia" || href === "#epikoinonia" || href === "/#epikoinonia") {
        window.gtag("event", "appointment_click", params);
      }
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);
  return null;
}
